/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sorter_Ref_IntroInputs */

const en_sorter_ref_intro = /** @type {(inputs: Sorter_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each row is a real pair of keys and the order this tool produces in ascending mode, next to what a plain code point comparison would have produced.`)
};

const ko_sorter_ref_intro = /** @type {(inputs: Sorter_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`각 행은 실제 키 쌍과, 이 도구가 오름차순 모드에서 만드는 순서, 그리고 단순 코드 포인트 비교라면 나왔을 순서입니다.`)
};

const ja_sorter_ref_intro = /** @type {(inputs: Sorter_Ref_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各行は実際のキーの組と、このツールが昇順モードで作る順序、そして単純なコードポイント比較なら出ていた順序です。`)
};

/**
* | output |
* | --- |
* | "Each row is a real pair of keys and the order this tool produces in ascending mode, next to what a plain code point comparison would have produced." |
*
* @param {Sorter_Ref_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sorter_ref_intro = /** @type {((inputs?: Sorter_Ref_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorter_Ref_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sorter_ref_intro(inputs)
	if (locale === "ko") return ko_sorter_ref_intro(inputs)
	return ja_sorter_ref_intro(inputs)
});